// extracted by mini-css-extract-plugin
export default {"container":"ResizeHandle_container__oGBSn","overflow":"ResizeHandle_overflow__U6XoL","overlay":"ResizeHandle_overlay__4t0Ar","handle":"ResizeHandle_handle__km1Kp"};